/* global anonymousLogin */

import React from 'react';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import firebase from '../Firebase.js';
import auth from '../FirebaseAuth.js';
import './SignInOut.scss';

export default class SignIn extends React.Component {

    componentDidMount() {
        this.unregisterAuthObserver = auth.onAuthStateChanged((user) => {
            if (user) {
                user.getIdToken().then(function(token) {
                    document.cookie = `token=${token}; path=/`;
                });
                window.location.href = '/r';
            }
        });
    }

    componentWillUnmount() {
        this.unregisterAuthObserver();
    }

    anonymousLogin() {
        auth.signInAnonymously().catch(function(error) {
            console.error('Error', error);
        });
    }

    renderAnon() {
        if (anonymousLogin) {
            return (
                <button type="button" className="test-button" onClick={this.anonymousLogin} > Anonymous Log In </button>
            );
        }
    }

    render() {
        const uiConfig = {
            signInSuccessUrl: '/r',
            signInOptions: [
                // Comment out any lines corresponding to providers you did not check in
                // the Firebase console.
                firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                {
                    provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
                    requireDisplayName: false,
                },
                //firebase.auth.FacebookAuthProvider.PROVIDER_ID,
                //firebase.auth.TwitterAuthProvider.PROVIDER_ID,
                //firebase.auth.GithubAuthProvider.PROVIDER_ID,
                //firebase.auth.PhoneAuthProvider.PROVIDER_ID

            ],
            // Terms of service url.
            tosUrl: '<your-tos-url>',
        };

        return (
            <div>
                <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={auth} />
                {this.renderAnon()}
            </div>
        );
    }
}
